class NavbarController {
    constructor($state, authService, sharedService) {
        'ngInject';

        this.$state = $state;
        this.authService = authService;
        this.loader = sharedService.loader;
        this.name = 'navbar';
    }

    logout() {
        this.authService.logout().then(() =>{
          this.$state.go('auth.login');
        });
    }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js